import { Controller } from 'stimulus'

// Inline feedback for links that kick off slow full-page requests (report
// exports etc.): reveals a spinner target and blocks re-clicks until the
// navigation completes.
export default class extends Controller {
  static targets = ['spinner']

  start() {
    this.spinnerTarget.classList.remove('hidden')
    this.element.classList.add('pointer-events-none')
  }
}
